/*
 * @Date: 2020-08-24 18:10:53
 * @Author: MX
 * @LastEditTime: 2020-08-31 14:09:03
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
import base from './module/base'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    base
  }
})
